<template>
  <div class="activity">
    <div class="title">
      <span></span>
      <div class="name overflow-text">{{ match?.chineseName }}</div>
      <div @click="goSchedule">更多</div>
    </div>
    <div class="vs" v-if="game.homeTeam">
      <div class="team">
        <div v-if="game.sportType === '棒球'">先攻</div>
        <img :src="filterImage(game.homeTeam.badge, 52, 52)">
        {{ game.homeTeam.name }}
        <div style="color: #ababab;">{{ bmGame.homeTeamAlias ? bmGame.homeTeam.name : '' }}</div>
        <img class="clothes" :src="require(`@/assets/images/${clothPrefix}${game.homeClothesColor}.png`)"
          v-if="game.type == 'game' && game.homeClothesColor > 0">
      </div>
      <div class="content">
        <span>{{ bmGame.roundDescription }}</span>
        <div class="score">
          <span v-if="bmGame.homeScore >= 0">{{ getRegularScore(bmGame, 'home') }} </span>
          <span> {{ (bmGame.homeScore >= 0 && bmGame.awayScore >= 0) ? '—' : 'VS' }} </span>
          <span v-if="bmGame.awayScore >= 0">{{ getRegularScore(bmGame, 'away') }}</span>
        </div>
        <div v-if="bmGame.homePenalty !== -1 && bmGame.awayPenalty !== -1" class="penalty">(点球: {{ bmGame.homePenalty }}:{{ bmGame.awayPenalty }})</div>
        <div @click="goLive" :style="{ color: gameStatusMap(bmGame).color }" class="state">{{ gameStatusMap(bmGame).label
        }}
        </div>
      </div>
      <div class="team">
        <div v-if="game.sportType === '棒球'">后攻</div>
        <img :src="filterImage(game.awayTeam.badge, 52, 52)">
        {{ game.awayTeam.name }}
        <div style="color: #ababab;">{{ bmGame.awayTeamAlias ? bmGame.awayTeam.name : '' }}</div>
        <img class="clothes" :src="require(`@/assets/images/${clothPrefix}${game.awayClothesColor}.png`)"
          v-if="game.type == 'game' && game.awayClothesColor > 0">
      </div>
    </div>
    <Referee class="referee" :referee="referee"></Referee>
    <div v-if="game.sportType === '足球'">
      <!-- 时间线1 -->
      <div class="stats" v-if="gameStats.homeTeamStats.length > 0 || gameStats.awayTeamStats.length > 0">
        <div class="top">
          <div v-for="stats in gameStats.homeTeamStats" :key="stats.playerId" class="item">
            <div style="margin-bottom: 5px;">{{ stats.playerInfo }}</div>
            <div style="display: flex;"><span style="margin-right: 6px" v-for="(item, index) in stats.details"
                :key="index" class="event-icon"><img :src="item.icon">x{{ item.quantity }}</span></div>
          </div>
        </div>
        <div class="top">
          <div v-for="stats in gameStats.awayTeamStats" :key="stats.playerId" class="item" style="text-align: right;">
            <div style="margin-bottom: 5px;">{{ stats.playerInfo }}</div>
            <div style="display: flex; justify-content: end;"><span style="margin-right: 6px"
                v-for="(item, index) in stats.details" :key="index" class="event-icon"><img :src="item.icon">x{{
                  item.quantity }}</span></div>
          </div>
        </div>
      </div>
      <!-- 时间线2 -->
      <div class="stats1" v-if="timeLineNodes.length > 0">
        <div class="hr"></div>
        <div v-for="(item, index) in timeLineNodes" :key="index">
          <div v-if="isExpandedMode || index < 4" class="item">
            <div><span v-if="item.homeTeamEvent">{{ item.homeTeamEvent.playerInfo }}</span></div>
            <div class="icon">
              <div><img :src="item.homeTeamEvent.eventIcon" v-if="item.homeTeamEvent"></div>
              <div>{{ item.time }}'</div>
              <div><img :src="item.awayTeamEvent.eventIcon" v-if="item.awayTeamEvent"></div>
            </div>
            <div style="text-align: right;"><span v-if="item.awayTeamEvent">{{ item.awayTeamEvent.playerInfo }}</span>
            </div>
          </div>
          <div v-if="(item.homeTeamEvent?.eventIcon2 || item.awayTeamEvent?.eventIcon2) && (isExpandedMode || index < 4)" class="item">
            <div><span v-if="item.homeTeamEvent?.otherPlayerInfo">{{ item.homeTeamEvent.otherPlayerInfo }}</span></div>
            <div class="icon">
              <div><img v-if="item.homeTeamEvent?.eventIcon2" :src="item.homeTeamEvent?.eventIcon2"></div>
              <div></div>
              <div><img v-if="item.awayTeamEvent?.eventIcon2" :src="item.awayTeamEvent?.eventIcon2"></div>
            </div>
            <div style="text-align: right;"><span v-if="item.awayTeamEvent?.otherPlayerInfo">{{
              item.awayTeamEvent.otherPlayerInfo }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="expandBar" @click="isExpandedMode = !isExpandedMode" v-if="timeLineNodes.length > 4">
        {{ isExpandedMode ? '收起' : '展开' }}
        <span :class="{ upward: isExpandedMode }"></span>
      </div>
    </div>
    <div v-if="game.sportType === '橄榄球'">
      <DataTable :gameId="gameId" :data="list" name="球队" code="rugby" @basketball="basketball" />
    </div>
    <div v-if="game.sportType === '篮球' || game.sportType === '排球' || game.sportType === '乒乓球' || game.sportType === '羽毛球'">
      <DataTable :gameId="gameId" :data="list" :name="$t('event.activity.text_7')" :sportType="game.sportType" :code="game.sportType === '篮球' || game.sportType === '乒乓球' || game.sportType === '羽毛球' ? 'basketball': 'volleyball'" @basketball="basketball" />
    </div>
    <div v-if="bmGame.sportType === '棒球'">
      <baseball-game-detail :game-id="gameId" :game-obj="bmGame" />
    </div>
    <div v-if="lives.length > 0 && bmGame.livePublic !== 0" class="video">
      <div class="video-title">
        <p>{{ $t('event.activity.text_4') }}</p>
      </div>
      <div class="video-box">
        <div v-for="(item, i) in lives" :key="item.id" v-show="i < 2">
          <div class="item" @click="goPages(item)">
            <img :src="filterImage(item.poster, 170, 90)" />
            <img src="@/assets/images/detail_livelist_playicon.png" class="playicon" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="game.sportType === '足球'">
       <Penalty />
    </div>
    <div class="data">
      <div class="item">
        <div class="left" v-html="$t('event.activity.text_1')"></div>
        <div class="right">{{ date[filterDate(bmGame.beginDate, 'd')] }} {{ filterDate(bmGame.beginDate, 'HH:mm') }}-{{
          filterDate(bmGame.endDate, 'HH:mm') }}&nbsp;&nbsp;({{ filterDate(bmGame.beginDate, 'yyyy/MM/DD') }})</div>
      </div>
      <div class="item">
        <div class="left" v-html="$t('event.activity.text_2')"></div>
        <div class="right">{{ bmGame.sportType }} <span v-if="bmGame.gameType">({{ bmGame.gameType }})</span></div>
      </div>
      <div class="item">
        <div class="left" v-html="$t('event.activity.text_3')"></div>
        <div class="right" style="line-height: 25px;">
          <div>{{ bmGame.venueName }}</div>
          <div>{{ bmGame.location }}</div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="game.sportType === '足球' && !jetlympic">
      <game-tabbar 
        :unionMatchId="unionMatchId"
        :matchId="matchId"
        :gameId="gameId"
        :homeTeamId="homeTeamId"
        :homeTeamName="homeTeamName"
        :awayTeamId="awayTeamId"
        :awayTeamName="awayTeamName"
        :registrationCapability="registrationCapability"/>
    </div>
  </div>
</template>

<script>
import { bkGetBMGameBktData, getBMGameDetail, getBMRugbyGameStats } from '@/api/match'
import { QNImageUtil } from "@/utils";
import Moment from 'moment'
import DataTable from '@/components/DataTable'
import BaseballGameDetail from "@/views/event/baseball-game-detail";
import Referee from './component/Referee'
import Penalty from './component/Penalty.vue'
import GameTabbar from '@/views/match-team-game/game-tabbar.vue'

export default {
  components: {
    BaseballGameDetail,
    DataTable,
    Referee,
    GameTabbar,
    Penalty
  },
  data() {
    return {
      gameId: '',
      game: {},
      bmGame: {},
      match: {},
      date: ['周末', '周一', '周二', '周三', '周四', '周五', '周六'],
      gameStats: { homeTeamStats: [], awayTeamStats: [] },
      timeLineNodes: [],
      isExpandedMode: false,
      list: [],
      lives: [],
      clothPrefix: 'qy_',
      referee: [],
      gameRollCall: 0,
      jetlympic: false,
      language: 'zh'
    }
  },
  computed: {
    unionMatchId() {
        if (this.game && this.game.unionMatchId) {
            return this.game.unionMatchId
        } else if (this.bmGame && this.bmGame.unionMatchId) {
            return this.bmGame.unionMatchId
        }
        return ''
    },
    matchId() {
      if (this.game && this.game.matchId) {
        return this.game.matchId
      }
      return ''
    },
    homeTeamId() {
      if (this.game && this.game.homeTeam) {
        return this.game.homeTeam.id
      }
      return ''
    },
    homeTeamName() {
      if (this.game && this.game.homeTeam) {
        return this.game.homeTeam.name
      }
      return ''
    },
    awayTeamId() {
      if (this.game && this.game.awayTeam) {
        return this.game.awayTeam.id
      }
      return ''
    },
    awayTeamName() {
      if (this.game && this.game.awayTeam) {
        return this.game.awayTeam.name
      }
      return ''
    },
    registrationCapability() {
      return this.gameRollCall == 1
    }
  },
  mounted() {
    if (window.localStorage.getItem('jetlympic')) {
      this.jetlympic = true
    }
    this.language = window.localStorage.getItem('language') || 'zh'
    this.gameId = this.$route.query.gameId
    this.bkGetBMGameBktData()
    this.getBMGameDetail()
  },
  methods: {
    // 计算常规时间比分（总分 - 点球 - 加时）
    getRegularScore(game, team) {
      if (!game) return ''
      
      const scoreKey = team === 'home' ? 'homeScore' : 'awayScore'
      const penaltyKey = team === 'home' ? 'homePenalty' : 'awayPenalty'
      const plusKey = team === 'home' ? 'homePlus' : 'awayPlus'
      
      // 安全地获取数值并转换为数字类型
      const totalScore = typeof game[scoreKey] === 'number' ? game[scoreKey] : (game[scoreKey] ? Number(game[scoreKey]) : -1)
      const penaltyScore = game[penaltyKey] && game[penaltyKey] !== -1 ? Number(game[penaltyKey]) : 0
      const plusScore = game[plusKey] && game[plusKey] !== -1 ? Number(game[plusKey]) : 0
      
      // 如果总分小于0或不是有效数字，说明没有比分数据，返回空字符串
      if (totalScore < 0 || isNaN(totalScore)) {
        return ''
      }
      
      // 常规时间 = 总分 - 点球 - 加时
      const regularScore = totalScore - penaltyScore - plusScore
      
      // 确保结果非负，如果计算结果为负则返回总分
      return regularScore >= 0 ? regularScore : totalScore
    },
    goLive() {
      if (this.bmGame.liveStatus.status === 1 || this.bmGame.liveStatus.status === 2) {
        this.$router.push({ path: `/live-page/${this.gameId}` })
      }
    },
    bkGetBMGameBktData() {
      bkGetBMGameBktData({ gameId: this.gameId }).then(res => {
        const data = res.data
        this.game = data.game
        this.match = data.match
        if (this.game.sportType === '橄榄球') {
          this.getBMRugbyGameStats()
        } else if (this.game.sportType === '篮球' || this.game.sportType === '排球' || this.game.sportType === '乒乓球' || this.game.sportType === '羽毛球') {
          const stages = data.stages
          let homeObj = {
            total: this.game.homeScore
          }
          let awayObj = {
            total: this.game.awayScore
          }
          stages.forEach((item, i) => {
            homeObj[i] = item.homeScore
            awayObj[i] = item.awayScore
          })
          let list = [
            {
              ...this.game.homeTeam,
              stats: homeObj
            },
            {
              ...this.game.awayTeam,
              stats: awayObj
            }
          ]
          this.list = list
        }
      })
    },
    getBMGameDetail() {
      getBMGameDetail({ gameId: this.gameId, eventMode: 0, simple: 0 }).then(res => {
        const data = res.data
        const game = data.game
        this.gameRollCall = game.rollCall
        document.title = this.match?.chineseName
        const shareObj = {
          title: this.game.homeTeam.name + 'Vs' + this.game.awayTeam.name,
          abstract: this.match?.chineseName + '/' + game.roundDescription,
          image: QNImageUtil.imageView(this.match?.icon)
        }
        this.wxShare(shareObj)
        this.lives = data.lives
        if (game.sportType === '篮球') {
          this.clothPrefix = 'basket_'
        } else if (game.sportType == '乒乓球' || game.sportType == '羽毛球') {
          this.clothPrefix = 'badminton_'
        }
        this.referee = game.referee
        this.bmGame = data.game
        if (data.game.originEventMode) {
          this.gameStats = this.buildGameStats(data.game)
        } else {
          this.timeLineNodes = this.buildTimeLine(data.game)
          console.log(this.timeLineNodes);
        }
      })
    },
    gameStatusMap(game) {
      var liveStatus = game.liveStatus
      var ret = {}
      if (liveStatus) {
        ret = {
          label: liveStatus.statusLabel // 默认label，默认字体颜色黑色
        }
        if (liveStatus.status === -3 || liveStatus.status === 0 || (liveStatus.status === -1 && liveStatus.statusLabel === '即将直播')) {
          ret.color = '#CF2F30'
          if (liveStatus.status === -3) {
            ret.label = '即将直播'
          }
        } else if ((liveStatus.status === -1 && liveStatus.statusLabel === '比赛进行中') || liveStatus.status === 1) {
          ret.color = '#CF2F30'
          if (liveStatus.status === 1) {
            ret.label = this.$t('match.schedule.text_2')
          }
        } else if (liveStatus.status === 2) {
          ret.color = '#369AD4'
        }
      } else if (game.stateDesc) {
        if (game.state === 1) {
          ret.color = '#38906B'
          ret.label = '等待开赛'
        } else if (game.state === 0) {
          ret.color = '#38906B'
          ret.label = '正在报名'
        } else if (game.state === 2) {
          ret.label = game.stateDesc
          ret.color = '#CF2F30'
        } else if (game.state === 3) {
          ret.label = game.stateDesc
        }
      } else {
        if (game.gameNotBegin === 1) {
          ret.color = '#38906B'
          ret.label = '即将开赛'
        } else if (game.gameEnd === 0) {
          ret.color = '#CF2F30'
          ret.label = '比赛进行中'
        } else {
          // ret.color = '#369AD4';
          ret.label = this.$t('match.schedule.text_3')
        }
      }
      if(liveStatus && liveStatus.statusLabel=='视频录像') {
        ret.label = this.$t('match.schedule.text_4')
      }
      return ret
    },
    buildGameStats(game) {
      const supportedEventType = ['goal', 'penalty', 'assist', 'red', 'yellow']
      const gameStats = { homeTeamStats: [], awayTeamStats: [] }
      const processedGameEvents = []// 这个数组存放将助攻事件分离出来的事件列表
      game.gameEvent.forEach(function (event) {
        processedGameEvents.push(event)
        if (event.type === 'goal' && (event.otherPlayerId || event.otherPlayerId.length > 0)) { // 基于有助攻的进球事件添加一个助攻事件
          var newEvent = JSON.parse(JSON.stringify(event))
          newEvent.type = 'assist'
          newEvent.teamId = event.teamId
          newEvent.playerId = event.otherPlayerId
          newEvent.userId = event.otherUserId
          newEvent.userName = event.otherName
          newEvent.userNumber = event.otherNumber
          processedGameEvents.push(newEvent)
        }
      })
      processedGameEvents.forEach(function (event) {
        if (supportedEventType.indexOf(event.type) >= 0) {
          var list = (event.teamId === game.homeTeamId ? gameStats.homeTeamStats : gameStats.awayTeamStats)
          if (game.sportType === '分组对抗') {
            list = (event.group === 0 ? gameStats.homeTeamStats : gameStats.awayTeamStats)
          }
          if (event.type === 'assist') {
            event.userName = event.otherName
            event.userNumber = event.otherNumber
          }
          var userNumber = event.userNumber ? '[' + event.userNumber + ']' : ''
          var playerInfo = event.userName + userNumber
          var existedPlayerStats = list.find(function (stats) {
            return stats.playerInfo === playerInfo
          })
          if (event.type === 'penalty') { // 将点球也统计为进球
            event.type = 'goal'
          }
          // var icon = 'images/game_icon_' + event.type + '.png'
          const icon = require(`@/assets/images/game_icon_${event.type}.png`)
          var statsDetail = { type: event.type, icon: icon, quantity: 1 }
          if (existedPlayerStats) {
            var details = existedPlayerStats.details
            var sameTypeItem = details.find(function (item) {
              return item.type === event.type
            })
            if (sameTypeItem) {
              sameTypeItem.quantity++
            } else {
              details.push(statsDetail)
            }
          } else {
            list.push({ teamId: event.teamId, playerId: event.playerId, playerInfo: playerInfo, details: [statsDetail] })
          }
        }
      })
      return gameStats
    },
    buildTimeLine(game) {
      var supportedEventType = ['goal', 'ownGoal', 'penalty', 'assist', 'red', 'yellow', 'changes'] // 用来判断足球需要展示的事件类型
      var supportedEventTypeObj = {}

      var hockeyEventType = ['goal', 'assist', 'penalty', 'leave2', 'leave5', 'leave10']
      var i; let event; var processedGameEvents = []
      for (i = 0; i < game.gameEvent.length; i++) {
        event = game.gameEvent[i]
        processedGameEvents.push(event)
      }
      var sortedGameEvents = processedGameEvents.sort(function (a, b) {
        return a.time - b.time
      })

      var filteredGameEvents = []
      sortedGameEvents.forEach(item => {
        // 根据运动类型选择不同的过滤条件
        const shouldInclude = game.sportType === '足球'
          ? supportedEventType.indexOf(item.type) >= 0
          : game.sportType === '冰球'
            ? hockeyEventType.indexOf(item.type) >= 0
            : true; // 其他运动类型不过滤

        if (shouldInclude) {
          filteredGameEvents.push(item)
          // 图标标记 (仅对足球运动进行)
          if (game.sportType === '足球' && !supportedEventTypeObj[item.type] && item.type !== 'changes') {
            supportedEventTypeObj[item.type] = require(`@/assets/images/game_icon_${item.type}.png`)
          }
        }
      })

      var nodesGroupedByTime = []; var timeLineNodes = []
      for (i = 0; i < filteredGameEvents.length; i++) { // 1 {type: ''}

        event = filteredGameEvents[i]
        var timeLineNode = { homeTeamEvent: { playerInfo: '' }, time: event.time, awayTeamEvent: { playerInfo: '' } }

        if (game.sportType === '足球') {
          this.$set(event, 'eventIcon', supportedEventTypeObj[event.type] || null)
          if (event.otherPlayerId || event.otherPlayerId.length > 0 || event.otherUserId || event.otherUserId.length > 0) {
            if (event.type === 'changes') {
              event.eventIcon = require(`@/assets/images/game_icon_up.png`)
              // event.eventIcon2 = require(`@/assets/images/game_icon_up.png`)
              this.$set(event, 'eventIcon2', require(`@/assets/images/game_icon_down.png`))
            } else if (event.type === 'goal') {
              event.eventIcon2 = require(`@/assets/images/game_icon_assist.png`)
            } else if (event.type === 'assist') {
              event.userName = event.otherName
              event.userNumber = event.otherNumber
              event.otherName = ''
              event.otherNumber = ''
            }
          }
        }
        if (game.sportType === '冰球') {
          event.eventIcon = hockeyEventType.indexOf(event.type) >= 0 ? 'images/hockey-' + event.type + '.png' : null
          if (event.otherPlayerId || event.otherPlayerId.length > 0 || event.otherUserId || event.otherUserId.length > 0) {
            if (event.type === 'goal') {
              event.eventIcon2 = 'images/hockey-assist.png'
            } else if (event.type === 'assist') {
              event.userName = event.otherName
              event.userNumber = event.otherNumber
              event.otherName = ''
              event.otherNumber = ''
            }
          }
        }
        var userNumber = event.userNumber ? '[' + event.userNumber + ']' : ''
        var otherNumber = event.otherNumber ? '[' + event.otherNumber + ']' : ''
        if (event.teamId === game.homeTeamId) {
          // event.playerInfo = event.userName + userNumber
          this.$set(event, 'playerInfo', event.userName + userNumber)
          if (event.otherPlayerId || event.otherPlayerId.length > 0 || event.otherUserId || event.otherUserId.length > 0) {
            this.$set(event, 'otherPlayerInfo', event.otherName + otherNumber)
          }
          timeLineNode.homeTeamEvent = event
        } else {
          // event.playerInfo = userNumber + event.userName
          this.$set(event, 'playerInfo', userNumber + event.userName)
          if (event.otherPlayerId || event.otherPlayerId.length > 0 || event.otherUserId || event.otherUserId.length > 0) {
            this.$set(event, 'otherPlayerInfo', otherNumber + event.otherName)
          }
          timeLineNode.awayTeamEvent = event
        }
        // 将单列排好序的比赛事件按时间和主客队分组存放在nodesGroupedByTime中
        var workingGroupedNode
        var lastGroupedNode = nodesGroupedByTime[nodesGroupedByTime.length - 1]
        if (i > 0 && lastGroupedNode.time === timeLineNode.time) {
          workingGroupedNode = lastGroupedNode
        } else {
          workingGroupedNode = { time: timeLineNode.time, homeTeamEvents: [], awayTeamEvents: [] }
          nodesGroupedByTime.push(workingGroupedNode)
        }
        if (timeLineNode.homeTeamEvent.teamId) {
          workingGroupedNode.homeTeamEvents.push(timeLineNode.homeTeamEvent)
        } else if (timeLineNode.awayTeamEvent.teamId) {
          workingGroupedNode.awayTeamEvents.push(timeLineNode.awayTeamEvent)
        }
      }
      // 根据单列按时间和球队分组的数据结构nodesGroupedByTime构造最均衡的两列式的时间轴节点列表
      nodesGroupedByTime.forEach(function (groupedNode) {
        var nodeCountOfSameTime = Math.max(groupedNode.homeTeamEvents.length, groupedNode.awayTeamEvents.length)
        for (var i = 0; i < nodeCountOfSameTime; i++) {
          var timeLineNode = { time: groupedNode.time }
          if (i < groupedNode.homeTeamEvents.length) {
            timeLineNode.homeTeamEvent = groupedNode.homeTeamEvents[i]
          }
          if (i < groupedNode.awayTeamEvents.length) {
            timeLineNode.awayTeamEvent = groupedNode.awayTeamEvents[i]
          }
          timeLineNodes.push(timeLineNode)
        }
      })
      return timeLineNodes
    },
    getBMRugbyGameStats() {
      const param = {
        mode: 1,
        gameId: this.gameId
      }
      getBMRugbyGameStats(param).then(res => {
        const data = res.data
        this.list.push(data.homeTeam)
        this.list.push(data.awayTeam)
      })
    },
    filterDate(date, type) {
      return Moment(date).format(type)
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    goPages(obj) {
      // if (process.env.NODE_ENV === 'development') {
      //   window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/video-detail?objType=${obj.objType}&objId=${obj.objId}&videoId=${obj.videoId}`
      // } else {
      //   window.location.href = `https://www.snsports.cn/webapp/index.html?redirect=video-detail&objType=${obj.objType}&objId=${obj.objId}&videoId=${obj.videoId}`
      // }
      this.$router.push({ path: `/live-page/${this.gameId}`, query: { videoId: obj.videoId } })
    },
    goMore() {
      if (process.env.NODE_ENV === 'development') {
        window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/live-list?gameId=${this.gameId}`
      } else {
        window.location.href = `https://www.snsports.cn/webapp/index.html?redirect=live-list&gameId=${this.gameId}`
      }
    },
    goSchedule() {
      this.$router.push({ path: '/match/MatchSchedule', query: { matchId: this.match.id } })
    },
    basketball() {
      if (this.game.sportType === '篮球') {
        if (process.env.NODE_ENV === 'development') {
          window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/basketball-data?gameId=${this.gameId}&language=${this.language}`
        } else {
          window.location.href = `https://www.snsports.cn/webapp/main.html#/basketball-data?gameId=${this.gameId}&language=${this.language}`
        }
      } else if (this.game.sportType === '橄榄球') {
        this.$router.push({ path: '/match/football-data', query: { gameId: this.gameId } })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.activity {
  background-color: #f2f2f2;
  height: 100vh;

  .title {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #ababab;
    border-bottom: 1px solid #f0f0f0;
    background-color: #fff;

    .name {
      flex: 1;
    }

    span {
      display: inline-block;
      width: 2px;
      height: 16px;
      background-color: #CF2F30;
      margin-right: 10px;
    }
  }

  .vs {
    background-color: #fff;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .team {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #656565;
      flex: 1;
      font-size: 12px;
      text-align: center;

      img {
        width: 52px;
        height: 52px;
        border-radius: 5px;
        margin-bottom: 10px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        margin-bottom: 10px;
        color: #9B9B9B;
        font-size: 12px;
      }

      .score {
        font-size: 18px;

        span {
          display: inline-block;
          margin: 0px 15px;
          font-weight: 600;
          color: #000;
        }
      }
      .penalty{
        font-size: 12px;
        color: #9B9B9B;
      }

      .state {
        font-size: 14px;
        margin-top: 8px;
      }
    }

    .clothes {
      width: 20px !important;
      height: 20px !important;
      position: absolute;
      top: 38px;
      left: 50%;
      margin-left: 10px;
    }
  }

  .stats {
    position: relative;
    display: flex;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
    font-size: 12px;

    .top {
      width: 50%;
      border-right: 1px solid #f0f0f0;
      padding: 15px;
      font-size: 14px;

      .item {
        padding: 8px 0;
      }

      .event-icon {
        display: flex;
        align-items: center;

      }

      img {
        width: 14px;
        height: 14px;
      }
    }
  }

  .stats1 {
    position: relative;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
    font-size: 12px;

    .hr {
      position: absolute;
      left: 50%;
      margin-left: -3px;
      width: 2px;
      height: 100%;
      background-color: #f0f0f0;
      z-index: 0;
    }

    .item {
      position: relative;
      display: flex;
      justify-content: space-between;
      padding: 12px 10px;
      color: #ababab;

      div {
        width: 30%;
      }

      .icon {
        width: 20%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        div {
          text-align: center;
          flex: 1;
          color: #000;
        }

        img {
          width: 14px;
          height: 14px;
          margin-top: 2px;
        }
      }
    }
  }

  .expandBar {
    border-top: 2px solid #f0f0f0;
    text-align: center;
    background: #fff;
    padding: 10px 0;
    font-size: 14px;

    span {
      display: inline-block;
      width: 0;
      height: 0;
      border-top: 4px dashed;
      border-right: 4px solid transparent;
      border-left: 4px solid transparent;
      border-bottom: 4px solid transparent;
      margin-bottom: 0px;
      transition: all 0.5s;
    }

    .upward {
      border-top: 4px solid transparent;
      border-bottom: 4px dashed;
      margin-bottom: 3px;
    }
  }

  .data {
    background-color: #fff;
    padding: 0 20px;
    margin-top: 30px;

    .item {
      display: flex;
      border-bottom: 1px solid #f2f2f2;
      min-height: 50px;
      line-height: 50px;
      font-size: 15px;

      .left {
        color: #ababab;
        font-weight: 500;
        min-width: 61px;
      }

      .right {
        margin-left: 15px;
        color: #656565;
      }
    }
  }

  .video {
    padding: 0 15px;
    background-color: #fff;
    margin-top: 20px;

    .video-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;

      p {
        margin: 0;
        height: 21px;
        border-left: 4px solid #cc3232;
        padding-left: 12px;
      }

      span {
        color: #9B9B9B;
        font-size: 14px;
      }
    }

    .video-box {
      display: flex;
      justify-content: space-between;
      padding-bottom: 5px;

      .item {
        position: relative;

        img {
          width: 170px;
          height: 90px;
        }

        .playicon {
          position: absolute;
          width: 36px;
          height: 36px;
          z-index: 9;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .football {}

  .footer {
    height: 50px;
    z-index: 10;
    position: fixed;
  }
}
</style>
